// confirm-component.ts
import { Component, inject } from '@angular/core';
import { OsStore } from '../../stores/os-store';

@Component({
  selector: 'app-confirm-component',
  standalone: true,
  templateUrl: './confirm-component.html',
  styleUrl: './confirm-component.css',
})
export class ConfirmComponent {
  readonly osStore = inject(OsStore);

  // On récupère les données de la modal depuis le store


  onCancel() {
    this.osStore.confirmWindow()?.onCancel?.();
    this.osStore.closeConfirmWindow();
  }

  onConfirm() {
    this.osStore.confirmWindow()?.onConfirm?.();
    this.osStore.closeConfirmWindow();
  }
}